import { useParams } from 'react-router-dom';

import FarmsOverview from '../../features/farms/layouts/overview';
import FarmStats from '../../features/farms/layouts/stats';

// TSS vite/01 §"Pages are thin". /admin/farms (lista) · /admin/farms/:id (estadísticas).
export default function FarmsPage() {
    const { id } = useParams();
    if (id) return <FarmStats farmId={id} />;
    return <FarmsOverview />;
}
